import { LitElement } from 'lit';

/**
 * Base class for components that render into light DOM so page-level Bootstrap styles apply.
 * Use plain LitElement (shadow DOM) only for self-contained widgets that bring their own styles.
 */
export abstract class LightElement extends LitElement {
  protected override createRenderRoot(): HTMLElement {
    return this;
  }
}
